import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal, InputGroup} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getDiscountList as onGetDiscountList,
    addDiscountList as onAddDiscountList,
    updateDiscountList as onUpdateDiscountList,
    deleteDiscountList as onDeleteDiscountList
} from "slices/discount/thunk";
import {searchDiscountList} from "helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";
import moment from "moment";

const DiscountList = () => {

    document.title = "Discount list";
    const dispatch = useDispatch<any>();

    const selectDiscountList = createSelector(
        (state: any) => state.Discount,
        (discount) => ({
            discountList: discount.discountList
        })
    );

    const {discountList} = useSelector(selectDiscountList);
    console.log(discountList)
    useEffect(() => {
        dispatch(onGetDiscountList());
    }, [dispatch]);


    const [listView, setListView] = useState<any>([]);
    const [discountLists, setDiscountLists] = useState<any>(null);
    const [addDiscount, setAddDiscount] = useState<boolean>(false);
    const [editDiscount, setEditDiscount] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    //add
    const handleCloseDiscount = () => {
        setAddDiscount(false);
    }
    const handleShowDiscount = () => setAddDiscount(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddDiscount(true);
        setEditDiscount(true);
        setEdit({
            id: lastItem.id,
            discount: lastItem.value,
            name: lastItem.name,
            status: lastItem.isActive,
            startDate: moment(lastItem.startDate, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm"),
            endDate: moment(lastItem.endDate, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm"),

        });

    }, []);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchDiscountList({page: 0, size: 500, search});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(discountList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setDiscountLists(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = discountLists.row.original.id || {};
        console.log(deleteData);
        if (deleteData) {
            dispatch(onDeleteDiscountList(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(discountList.content);
    }, [discountList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Discount name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Discount %",
                accessorKey: "value",
                enableColumnFilter: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.original.value}%</span>
                    )
                },
                enableSorting: true,
            },
            {
                header: "Start Date",
                accessorKey: "startDate",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "End Date",
                accessorKey: "endDate",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );

    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (edit && edit.name) || '',
            discount: (edit && edit.discount) || '',
            startDate: (edit && edit.startDate) || '',
            endDate: (edit && edit.endDate) || '',
            id: edit && edit.id,
            status: (edit && edit.status) || 'true',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Your Name"),
            discount: Yup.string().required("Please Enter Your Discount"),
            startDate: Yup.string().required("Please Enter Your Start Date"),
            endDate: Yup.string().required("Please Enter Your Start Date"),
            status: Yup.string().required("Please Enter Your Status"),
        }),

        onSubmit: (values: any) => {

            if (editDiscount) {
                const data: any = {
                    id: values.id,
                    name: values.name,
                    value: values.discount,
                    startDate: moment(values.startDate).format("DD/MM/YYYY HH:mm:ss"),
                    endDate: moment(values.startDate).format("DD/MM/YYYY HH:mm:ss"),
                    isActive: values.status
                }
                dispatch(onUpdateDiscountList(data));
                formik.resetForm();

            } else {
                const data: any = {
                    name: values.name,
                    value: values.discount,
                    startDate: moment(values.startDate).format("DD/MM/YYYY HH:mm:ss"),
                    endDate: moment(values.startDate).format("DD/MM/YYYY HH:mm:ss"),
                    isActive: values.status
                }

                dispatch(onAddDiscountList(data));
                formik.resetForm();
            }
            if (values === null) {
                handleShowDiscount();
            } else {
                setEdit(null);
                setEditDiscount(false);
                handleCloseDiscount();
            }
        }
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="discountList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Discount List</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search discount..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowDiscount}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    Discount
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addDiscount} onHide={handleCloseDiscount}>
                <Modal.Header closeButton>
                    <Modal.Title>{editDiscount ? "update Discount List" : "Add Discount"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>

                        <div className="mb-3">
                            <Form.Label htmlFor="discount-name">Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="discount-name"
                                name="name"
                                placeholder="Name..."
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.name}
                            />
                            {formik.errors.name && formik.touched.name ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="discount-value">
                                Discount <span className="text-danger">*</span>
                            </Form.Label>

                            <InputGroup hasValidation>
                                <InputGroup.Text id="discount-value">%</InputGroup.Text>
                                <Form.Control
                                    type="number"
                                    id="discount-value"
                                    name="discount"
                                    placeholder="value..."
                                    value={formik.values.discount}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isInvalid={!!formik.errors.discount}/>
                                {formik.errors.discount && formik.touched.discount ? (
                                    <Form.Control.Feedback
                                        type="invalid">{formik.errors.discount}</Form.Control.Feedback>
                                ) : null}
                            </InputGroup>
                        </div>
                        <div className="mb-3">
                            <Form.Label
                                htmlFor="status-select">Status</Form.Label>
                            <Form.Select
                                id="status-select"
                                name="status"
                                value={formik.values.status}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.status}>
                                <option value="false">No Active</option>
                                <option value="true">Active</option>
                            </Form.Select>
                            {formik.errors.status && formik.touched.status ? (
                                <Form.Control.Feedback
                                    type="invalid"> {formik.errors.status} </Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="startDate">Start date<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="datetime-local"
                                id="startDate"
                                name="startDate"
                                value={formik.values.startDate}
                                onChange={(e) => {
                                    const rawValue = e.target.value;
                                    formik.setFieldValue("startDate", rawValue);
                                }}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.startDate}
                            />
                            {formik.errors.startDate && formik.touched.startDate ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.startDate}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="endDate">End date<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="datetime-local"
                                id="endDate"
                                name="endDate"
                                value={formik.values.endDate}
                                onChange={(e) => {
                                    const rawValue = e.target.value;
                                    formik.setFieldValue("endDate", rawValue);
                                }}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.endDate}
                            />
                            {formik.errors.endDate && formik.touched.endDate ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.endDate}</Form.Control.Feedback>
                            ) : null}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseDiscount}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editDiscount ? "update" : "Add Discount"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default DiscountList;